import { useState, useEffect, useCallback } from 'react';
import { getCalculationRules } from '@/api/TournamentManagement/workPointApi';
import type { WorkPointRuleView } from '@/models/tournament';

export function useWorkPointRules() {
  const [data, setData] = useState<WorkPointRuleView[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await getCalculationRules();
      if (result.status < 400 && result.errors.length === 0) {
        setData(result.payload);
      } else {
        setError(result.errors[0]?.description || 'An error occurred');
      }
    } catch {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, loading, error, refetch: fetch };
}
